<script>
    import GameEditHeader from '@/components/page-provider-and-game-edit/game-edit/GameEditHeader.vue';
    import GameEditData from '@/components/page-provider-and-game-edit/game-edit/GameEditData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_PAG_GAME_EDIT}
        },
        components: {
            GameEditHeader: GameEditHeader,
            GameEditData: GameEditData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <GameEditHeader />
        <hr class="hr_light_98">
        <GameEditData />
    </div>
</template>